(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4352],{

/***/ 14352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ products; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 2 modules
var TransitionGroup = __webpack_require__(89747);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js + 3 modules
var CSSTransition = __webpack_require__(76743);
// EXTERNAL MODULE: ./components/index.js + 177 modules
var components = __webpack_require__(74030);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/lib/index.js
var lib = __webpack_require__(51655);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./lib/getLinkProps.js
var getLinkProps = __webpack_require__(89729);
// EXTERNAL MODULE: ./containers/products/Products.module.scss
var Products_module = __webpack_require__(91018);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./containers/products/Products.js




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var Products = function Products(_ref) {
  var products = _ref.products,
      loadingProducts = _ref.loading,
      productCardProps = _ref.productCardProps,
      isSafari = _ref.isSafari,
      currency = _ref.currency,
      slug = _ref.slug,
      state = _ref.state;

  var _useState = (0,react.useState)(products),
      items = _useState[0],
      setItems = _useState[1];

  var _useState2 = (0,react.useState)(true),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0,react.useState)([true]),
      skeleton = _useState3[0],
      setSkeleton = _useState3[1];

  var getLink = function getLink(slug) {
    var _getLinkProps = (0,getLinkProps/* default */.Z)({
      type: 'product',
      value: slug
    }),
        _getLinkProps2 = (0,slicedToArray/* default */.Z)(_getLinkProps, 2),
        linkAs = _getLinkProps2[1];

    return linkAs;
  };

  var nameCategory = (0,react.useMemo)(function () {
    var nameSlug = 'Категории';

    if (slug.includes('brand')) {
      nameSlug = 'Бренды';
    } else if (slug.includes('sale')) {
      nameSlug = 'Распродажи/Sale';
    }

    return "\u041A\u0430\u0442\u0430\u043B\u043E\u0433 \u0442\u043E\u0432\u0430\u0440\u043E\u0432: ".concat(nameSlug);
  }, [slug]);
  (0,react.useEffect)(function () {
    var goods = (0,toConsumableArray/* default */.Z)(products);

    setItems(goods);
  }, [products]);
  (0,react.useEffect)(function () {
    if (loadingProducts) {
      setLoading(true);
    } else {
      setTimeout(function () {
        setLoading(false);
      }, 0);
    }
  }, [loadingProducts]);
  (0,react.useEffect)(function () {
    if (loading) {
      var interval = setInterval(function () {
        setSkeleton(function (prevState) {
          if (prevState.length < 6) {
            return [].concat((0,toConsumableArray/* default */.Z)(prevState), [true]);
          }

          return prevState;
        });
      }, 250);
      return function () {
        return clearInterval(interval);
      };
    } else {
      setSkeleton([true]);
    }
  }, [loading]);

  var handleClickCard = function handleClickCard(product, index) {
    Ecommerce/* default.viewItemList */.ZP.viewItemList([product], currency, nameCategory, 'select_item', index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: (Products_module_default()).productList,
    children: loading ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: skeleton.map(function (_item, idx) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          className: (Products_module_default()).productListLoading,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
            count: 1,
            height: "70%",
            width: "100%",
            style: {
              marginBottom: '24px'
            }
          }, "".concat(idx, "-skeleton-product1")), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
            count: 1,
            height: "5%",
            width: "30%",
            style: {
              marginBottom: '8px'
            }
          }, "".concat(idx, "-skeleton-product2")), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
            count: 1,
            height: "7%",
            width: "100%",
            style: {
              marginBottom: '8px'
            }
          }, "".concat(idx, "-skeleton-product3")), /*#__PURE__*/(0,jsx_runtime.jsx)(lib/* default */.ZP, {
            count: 1,
            height: "5%",
            width: "35%",
            style: {
              marginBottom: '8px'
            }
          }, "".concat(idx, "-skeleton-product4"))]
        }, idx);
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TransitionGroup/* default */.Z, {
      component: null,
      exit: false,
      children: items.map(function (item, ind) {
        var external_id = item.external_id;
        return /*#__PURE__*/(0,jsx_runtime.jsx)(CSSTransition/* default */.Z, {
          in: true,
          timeout: {
            appear: 0,
            enter: 250,
            exit: 0
          },
          classNames: "on",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            id: getLink(item.model.slug),
            itemType: "https://schema.org/Product",
            itemScope: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              onClick: function onClick() {
                handleClickCard(item, ind + 1);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(components/* ProductCard */.Il, _objectSpread(_objectSpread(_objectSpread({}, item), productCardProps), {}, {
                isSafari: isSafari,
                pageName: nameCategory,
                indexCard: ind + 1,
                newCurrency: currency,
                state: state
              }))
            })
          })
        }, external_id);
      })
    })
  });
};

/* harmony default export */ var products_Products = (Products);
;// CONCATENATED MODULE: ./containers/products/index.js

/* harmony default export */ var products = (products_Products);

/***/ }),

/***/ 91018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"productList":"Products_productList__8pie9","productListLoading":"Products_productListLoading__FocCn","load":"Products_load__4NE7v"};

/***/ })

}]);